<template>
  <div class="container" :style="white ? 'background: white;' : ''">
    <div class="label">{{ label }}</div>
    <div>
      <button type="button" @click="decrement" :disabled="lastMessage === false || value <= 0" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }">-</button>
      <span>{{ value }}</span>
      <button type="button" @click="increment" :disabled="lastMessage === false" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }">+</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chatbotColors: {
      type: Object,
      required: true
    },
    label:{
      type: String,
      required: true
    },
    value:{
      type: Number,
      required: true
    },
    white:{
      type: Boolean,
      required: false,
      default: false
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    decrement () {
      this.$emit('input', this.value - 1);
    },
    increment () {
      this.$emit('input', this.value + 1);
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #eaeaea;
  padding: 5px 10px;
  font-size: 0.8rem;
}
button {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  border: 0;
}
button:hover {
  opacity: .8;
  cursor: pointer;
}
button:disabled {
  opacity: .3;
  cursor: default;
}
span {
  display: inline-block;
  margin: 0 5px;
}
</style>
